export default __webpack_public_path__ + "img/dIyoCdno.9332d304.svg";